import { CateringProductsTranslations } from "./catering-products-pt-br";

export const CATERING_PRODUCTS_ES_MX: CateringProductsTranslations = {
	title: "Catering",
	description:
		"Listado y configuración de artículos usados en propuestas de servicios de Catering.",
	addProduct: "Agregar producto",
	addCombo: "Agregar combo",
	addMenu: {
		standalone: "Único / armable",
		combo: "Combo",
		importSpreadsheet: "Importar desde planilla",
	},
	searchPlaceholder: "Buscar producto",
	allCategories: "Todas las categorías",
	tabs: {
		products: "Productos",
		combos: "Combos",
		standalone: "Estándar",
		mountable: "Armables",
	},
	table: {
		product: "PRODUCTO",
		category: "CATEGORÍA",
		type: "TIPO",
		price: "PRECIO",
	},
	typeLabels: {
		Product: "Estándar",
		Combo: "Combo",
		Mountable: "Montable",
	},
	emptyState: "No se encontraron productos",
	deleteConfirm: {
		title: "Eliminar producto {{productName}}",
		subtitle: "¡Atención! El producto se eliminará permanentemente.",
		confirmAction: "Eliminar producto",
		bulkTitle: "Eliminar productos seleccionados ({{count}})",
		bulkSubtitle: "¡Atención! Los productos se eliminarán permanentemente.",
		bulkConfirmAction: "Eliminar productos",
	},
	floatingBar: {
		deleteSelected: "Eliminar {{count}} productos",
	},
	notifications: {
		priceUpdated: "Precio actualizado con éxito.",
		productRemoved: "Producto eliminado con éxito.",
		productsRemovedPartial: "{{ok}} producto(s) eliminado(s), {{failed}} con fallo.",
		productRemoveFailed: "No fue posible eliminar el producto.",
		productCreated: "Producto creado con éxito.",
		productUpdated: "Producto actualizado con éxito.",
		comboCreated: "Combo creado con éxito.",
		comboUpdated: "Combo actualizado con éxito.",
		importSuccess: "{{ok}} producto(s) importado(s) con éxito.",
		importPartial: "{{ok}} producto(s) importado(s), {{failed}} con fallo.",
		importFailed: "No fue posible importar los productos.",
		exportFailed: "No fue posible exportar los productos.",
	},
	priceEdit: {
		validation: {
			pricePositive: "El precio debe ser un valor positivo",
			maxValue: "El precio no debe superar el valor máximo permitido (21,474,836.47)",
		},
		changeModal: {
			title: "Cambiar precio del producto",
			description:
				"Estás cambiando el precio del producto <strong>{{productName}}</strong> a <strong>{{price}}</strong>.",
			secondParagraph:
				"Antes de salir de la edición del precio, confirma si deseas continuar con el cambio o cancelar.",
		},
		invalidModal: {
			title: "Valor inválido",
			description:
				"El valor ingresado no es válido. Se mantendrá el precio anterior del producto.",
		},
	},
	categoryCombobox: {
		newCategoryWarning: "Se creará una nueva categoría con el nombre ingresado.",
		createCategory: 'Crear "{{name}}"',
	},
	comboForm: {
		title: "Agregar combo",
		editTitle: "Editar combo",
		save: "Guardar combo",
		details: {
			title: "Detalles del combo",
			subtitle: "Información general y precios",
			imageAriaLabel: "Imagen del combo",
			imageSubtitle:
				"Haz clic o arrastra la imagen. Tamaño recomendado: 500 x 500 píxeles.",
			fields: {
				name: { label: "Nombre", placeholder: "Nombre del producto" },
				category: { label: "Categoría", placeholder: "Bebida" },
				price: { label: "Precio", placeholder: "00,00" },
				description: {
					label: "Descripción",
					placeholder: "Escribe la descripción del combo.",
				},
			},
		},
		products: {
			title: "Agrega productos al combo",
			searchPlaceholder: "Escribe el nombre de un producto",
			emptyState: "No se encontraron productos",
			catalogEmpty:
				"Es necesario registrar productos individuales antes de crear un combo.",
			selected: "{{count}} producto(s) seleccionado(s)",
			countLabel: "Cant.",
		},
	},
	productForm: {
		tabs: {
			details: "Detalles del producto",
			mountable: "Producto armable",
		},
		mountableLocked: "Para agregar productos armables, crea un producto nuevo.",
		save: "Guardar producto",
		sections: {
			generalInfo: {
				title: "Detalles del producto",
				subtitle: "Información general y precios",
				imageAriaLabel: "Imagen del producto",
				imageSubtitle:
					"Haz clic o arrastra la imagen. El tamaño recomendado es de 500 x 500 píxeles.",
				fields: {
					name: {
						label: "Nombre",
						placeholder: "Nombre del producto",
					},
					category: {
						label: "Categoría",
						placeholder: "Bebida",
					},
					price: {
						label: "Precio (opcional)",
						placeholder: "00.00",
					},
				},
			},
			mountable: {
				title: "Producto armable",
				subtitle:
					"Los productos armables permiten al cliente combinar una base fija con una variedad de ingredientes adicionales.",
				stepLabel: "Etapa",
				addStep: "Etapa",
				removeStep: "Eliminar etapa",
				fields: {
					title: {
						label: "Título",
						placeholder: "Ingresa el título de la etapa",
					},
					pricing: {
						label: "Precificación",
						placeholder: "Elige un método",
						options: {
							sum: "Sumar",
							average: "Promedio",
							higher: "Mayor",
						},
					},
					min: {
						label: "Valor mínimo",
						placeholder: "00.00",
					},
					max: {
						label: "Valor máximo",
						placeholder: "00.00",
					},
				},
				items: {
					title: "Ingredientes adicionales",
					addItem: "Agregar otro artículo",
					removeItem: "Eliminar artículo",
					fields: {
						product: {
							label: "Artículo",
							placeholder: "Selecciona un artículo",
						},
						price: {
							label: "Valor",
							placeholder: "00.00",
						},
						maxCount: {
							label: "Cantidad máxima seleccionable",
							placeholder: "Ingresa la cantidad",
						},
						storageCount: {
							label: "Cantidad descontada del stock",
							placeholder: "0",
						},
					},
				},
			},
		},
		validation: {
			name: {
				required: "Ingresa el nombre del producto",
				min: "El nombre debe tener al menos 3 caracteres",
				max: "El nombre debe tener como máximo 100 caracteres",
			},
			category: {
				required: "Selecciona una categoría",
			},
			value: {
				required: "Ingresa el precio",
				invalid: "Precio inválido",
				min: "El precio debe ser un valor positivo",
				max: "El precio no debe superar el valor máximo permitido",
			},
			combo: {
				description: {
					max: "La descripción debe tener como máximo 500 caracteres",
				},
				products: {
					required: "Selecciona al menos 1 producto",
				},
				product: {
					productId: {
						required: "Producto inválido",
					},
					count: {
						min: "La cantidad debe ser al menos 1",
					},
				},
			},
			mountable: {
				sections: {
					required: "Agrega al menos 1 etapa",
				},
				title: {
					required: "Ingresa el título de la etapa",
				},
				pricing: {
					required: "Selecciona una regla de precio",
					invalid: "Regla de precio inválida",
				},
				max: {
					min: "El máximo debe ser al menos 1",
					greaterThanMin: "El máximo debe ser mayor o igual al mínimo",
				},
				items: {
					required: "Agrega al menos 1 artículo a la etapa",
				},
				item: {
					productId: {
						required: "Selecciona un producto",
						duplicate: "Producto duplicado en la misma etapa",
					},
					price: {
						min: "El precio del artículo debe ser positivo",
						max: "Valor máximo excedido",
					},
					storageCount: {
						min: "La cantidad en stock debe ser al menos 1",
						max: "Valor máximo excedido",
					},
				},
			},
		},
	},
};
